// extracted by mini-css-extract-plugin
export var cancelButton = "_mg-5";
export var content = "_mg-3";
export var createButton = "_mg-6";
export var drawerContainer = "_mg-0";
export var footer = "_mg-2";
export var header = "_mg-1";
export var orderFormColumn = "_mg-4";